import type {Entry} from "./types";

export class Entries {

    protected entries: Entry[] = [];

    constructor() {
        this.entries = [];
    }

    public clear(): void {
        this.entries = [];
        this.populate([]);
    }

    public add(entry: Entry): void {
        this.entries.push(entry);
    }

    public remove(entry: Entry): void {
        this.entries = this.entries.filter(e => e.id !== entry.id);
    }

    public populate(entries: Entry[]): void {
        this.entries = JSON.parse(JSON.stringify(entries));
    }

    public getAll(): Entry[] {
        return this.entries;
    }

}
